export const REWARDS_REFETCH_MAX_ATTEMPTS = 3;
export const REWARDS_REFETCH_POLLING_INTERVAL = 1500;
